<template>
  <div>
    <div v-if="account.show">
      <van-popup v-model="show" round position="center" @click-overlay="account.close()" :close-on-click-overlay="false">
        <div class="login-box">
          <div class="lg-inner">
            <div class="tabs">
              <div class="t-item" :class="info.mode == 'CARSI' && 'active'" @click="account.change('CARSI')">CARSI认证
              </div>
              <div class="t-item" :class="info.mode == 'sms' && 'active'" @click="account.change('sms')">验证码登录</div>
              <div class="t-item" :class="info.mode == 'account' && 'active'" @click="account.change('account')">密码登录
              </div>
            </div>
            <div class="account-box">
              <template v-if="info.mode == 'account'">
                <div class="input-group">
                  <span class="icon iconfont icon-yonghu"></span>
                  <input class="form-control" type="text" placeholder="输入账号" v-model="info.account">
                </div>
                <div class="input-group">
                  <span class="icon iconfont icon-lock-full"></span>
                  <input class="form-control" type="password" placeholder="输入密码" v-model="info.password">
                </div>
              </template>
              <template v-if="info.mode == 'sms'">
                <div class="input-group">
                  <span class="icon iconfont icon-shouji"></span>
                  <input class="form-control" type="text" name="tel" placeholder="输入手机号" v-model="info.account">
                </div>
                <div class="input-btn-group">
                  <div class="input-group">
                    <span class="icon iconfont icon-yanzhengma"></span>
                    <input class="form-control" type="text" placeholder="输入验证码" v-model="info.code">
                  </div>
                  <template v-if="second == null">
                    <button type="button" class="input-ri-btn" @click="account.send()">发送验证码</button>
                  </template>
                  <template v-if="second != null">
                    <button type="button" class="input-ri-btn">{{ second + ' s' }}</button>
                  </template>
                </div>
                <template v-if="!empower.show">
                  <van-checkbox v-model="checked" shape="square" icon-size="2rem" class="account-checkbox">
                    我已阅读并同意
                    <span class="checkedlink" @click.self="$com.to.path('/Agreement')">《用户协议》</span>
                  </van-checkbox>
                </template>
              </template>
              <template v-if="info.mode == 'CARSI'">
                <div class="carsi-login">
                  <div class="carsi-logo"><img @click="account.submit()" src="@/assets/carsi_login.png"></div>
                  <div class="ts-info">*未注册用户验证后将自动注册并登录</div>
                </div>
              </template>
              <button type="button" class="loginBtn" @click="account.submit()">立即登录</button>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <div v-if="empower.show">
      <van-popup v-model="show" round position="bottom" @click-overlay="empower.close()" :close-on-click-overlay="false">
        <div class="popup-content">
          <div class="popup-title">登录后可立即使用</div>
          <div class="popup-ts">微信登录后绑定手机，可实现两种登录方式的账户互通</div>
          <van-checkbox v-model="checked" shape="square" icon-size="2rem" class="pp-checkbox">我已阅读并同意<span
              class="checkedlink" @click.self="$com.to.path('/Agreement')">《用户协议》</span></van-checkbox>
          <div class="btns-group">
            <div class="btn-item btn-gray" @click="account.open()">手机号登录</div>
            <div class="btn-item btn-blue" @click="empower.submit()">微信快捷登录</div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      login: state => state.login
    })
  },
  data() {
    return {
      show: true,
      lock: true,
      account: {
        show: false,
        lock: false,
        open: () => {
          if (!this.checked) {
            return this.$com.message.alert("登录前请阅读并同意用户协议!");
          }
          this.account.show = true;
          this.account.lock = false;
        },
        close: () => {
          if (this.account.lock) {
            return;
          }
          this.account.show = false;
          this.$com.quick.login.close();
        },
        change: (val) => {
          this.info.mode = val;
          if (val == "account") {
            this.info.code = null;
            this.second = null;
          } else {
            this.info.password = null;
          }
          this.info.account = null;
        },
        send: () => {
          if (!this.checked) {
            return this.$com.message.alert("登录前请阅读并同意用户协议!");
          }
          this.$com.sms.send(this.info.account).then(() => {
            this.second = 60;
            var interval = setInterval(() => {
              this.second--;
              if (this.second <= 0) {
                this.second = null
                clearInterval(interval);
              }
            }, 1000);
          });
        },
        submit: () => {
          if (this.info.mode == "CARSI") {
            this.$com.sys.logout.remove();
            this.$api.CarsiLogin({ 'terminal': '2' }).then((res) => {
              if (res.code != 1) {
                return this.$com.message.error(res.info);
              }
              window.location.href = res.data;
            });
            return;
          }
          if (!this.info.account) {
            return this.$com.message.error(this.info.mode == "account" ? "请输入账号" : "请输入手机号码");
          }
          // 账号登陆
          if (this.info.mode == "account" && !this.info.password) {
            return this.$com.message.error("请输入密码");
          }
          if (this.info.mode == "sms") {
            if (!this.info.code) {
              return this.$com.message.error("请输入验证码");
            }
            if (!this.checked) {
              this.$com.message.alert("登录前请阅读并同意用户协议");
              return;
            }
          }
          if (this.$com.member.oauth.get()) {
            this.info.oauth = this.$com.member.oauth.get();
          }
          if (localStorage.getItem('referrerId')) {
            this.info.referrerId = localStorage.getItem('referrerId');
          }
          this.submit(this.info);
        }

      },
      empower: {
        show: false,
        lock: false,
        close: () => {
          if (this.empower.lock) {
            return;
          }
          this.empower.show = false;
          this.$com.quick.login.close();
        },
        submit: () => {
          if (!this.checked) {
            return this.$com.message.alert("请阅读并同意用户协议");
          }
          var info = {
            schoolId: this.$com.org.code(),
            referrerId: localStorage.getItem('referrerId'),
            oauth: this.$com.member.oauth.get(),
            invite: this.$com.invite.get()
          };
          if (!info.oauth) {
            return this.$com.message.alert("授权失败，请从公众号进入!");
          }
          this.submit(info);
        }
      },
      checked: false,
      second: null,
      info: {
        schoolId: this.$com.org.code(),
        mode: "CARSI",//CARSI sms
        account: null,
        password: null,
        code: null
      }
    }
  },
  methods: {
    submit(info) {
      // 是否授权
      info.empower = this.$com.org.get().empower;
      info.invite = this.$com.invite.get();

      this.$api.Login(info).then((res) => {
        if (res.code != 1) {
          return this.$com.message.error(res.info);
        }
        this.$com.member.login(res.data).then(() => {
          this.$com.message.success("登录成功");
          location.replace(location.href);
        });
      });
    },
  },
  watch: {
    login(val) {
      if (!val) {
        return;
      }
      if (this.$com.wx.platform()) {
        this.empower.show = true;
        return;
      }
      this.account.show = true;
    },
    $route(to, from) {
      this.$com.quick.login.close();
      this.empower.show = false;
      this.empower.lock = false;
      this.account.show = false;
      this.account.lock = false;

      // 判断该路由是否需要登录权限
      var member = this.$com.member.get();
      if (to.meta.verify && (!member || member.overt)) {
        if (this.$com.wx.platform()) {
          this.empower.show = true;
          this.empower.lock = true;
          return;
        }
        this.account.show = true;
        this.account.lock = true;
      }
    }
  }
}
</script>
<!-- 微信登陆 -->
<style lang="stylus" scoped>
.popup-content
  padding('',2rem)
  .popup-title
    font-size 1.6rem
    font-weight bold
  .popup-ts
    color $blackColor_2
    font-size 1.2rem
    line-height: 1.6667;
    overflow-wrap: break-word;
    text-align: justify;
  .pp-checkbox
    margin('top',3rem)
    .checkedlink
      color $blue
  .btns-group
    MixinsFlex(nowrap,'justify','center')
    margin('top',1.5rem)
    gap 0 2rem
    .btn-item
      width 100%
      height 5rem
      line-height 5rem
      text-align center
      border('radius',.6rem)
      font-weight bold
      flex-shrink 1
      flex-grow 0
    .btn-gray
      background $grey_5
      color $blackColor_1
    .btn-blue
      background $blue
      color $bgWhite
</style>
<!-- 账号登陆 -->
<style lang="stylus" scoped>
.login-box
  position relative
  width 37rem
  max-width 100%
  background #0d5899
  overflow hidden
  .lg-inner
    position relative
    z-index 2005
    .lg-title
      color #fff
      font-size 2rem
      font-weight bold
      padding('',1rem 0)
      text-align center
    .tabs
      MixinsFlex(nowrap,'center','center')
      padding('',2rem 0 0 0)
      gap 0 1rem
      .t-item
        width auto
        flex-shrink 1
        flex-grow 0
        text-align center
        color #dbe5f5
        font-weight bold
        padding('',0rem 2rem)
        height 4rem
        line-height 4rem
        user-select none
        cursor pointer
      .active
        background #fff
        color #2265cb
        border-top-left-radius .7rem
        border-top-right-radius .7rem
    .account-box
      background #fff
      padding('',2rem)
      border('radius',16px)
      margin('top',-.1rem)
      .input-group
        padding('',.5rem 1.5rem)
        background #f2f3f8
        border('radius',5rem)
        margin('bottom',1.5rem)
        MixinsFlex(nowrap,'start','center')
        .icon
          margin('right',1rem)
          color #9ab5e0
          flex-shrink 0
          flex-grow 0
        .form-control
          width 100%
          background none
      .input-btn-group
        margin('bottom',1.5rem)
        MixinsFlex(nowrap,'justify','center')
        gap 0 1.5rem
        .input-group
          margin('',0)
        .input-ri-btn
          flex-shrink 0
          flex-grow 0
          background #0d5899
          color #fff
          padding('',.9rem 1.5rem)
          border('radius',5rem)
          min-width 6rem
      .loginBtn
        width 100%
        height 4.5rem
        line-height 4.5rem
        background #0d5899
        color #fff
        font-weight bold
        border('radius',5rem)
        margin('top',1rem)
.login-box:before,.login-box:after
  content ''
  display inline-block
  position absolute
  background #075192
  border('radius',100%)
  z-index 2004
.login-box:before
  left -7rem
  top -11rem
  width 15rem
  height 15rem
.login-box:after
  right -11rem
  top 2rem
  width 25rem
  height 25rem
.carsi-login
  .carsi-logo
    margin('',1rem 0 2rem 0)
    width 100%
    MixinsFlex(nowrap,'center','center')
    img
      width 14rem
      height 14rem
      object-fit contain
  .ts-info
    color #666
    margin('',.5rem 0)
</style>
<style lang="stylus">
  .account-checkbox
    MixinsFlex(nowrap,'start','center')
    margin('',2rem 0 1rem 0)
    .van-checkbox__icon
      position relative
    .van-checkbox__label
      line-height 1.5
      padding('top',.2rem)
      .checkedlink
        color $blue
</style>



// WEBPACK FOOTER //
// src/components/quick/QuickLoginView.vue